module.exports = __webpack_public_path__ + "img/tn.2a091eb3.svg";